import { Stack, Text } from '@mantine/core';
import dayjs from 'dayjs';
import { type ServiceEvent, useServiceEvents } from '@/models/clientCompanies';

const day = (v: unknown) => {
  if (v == null || v === '') return '-';
  const [y, m, d] = String(v).slice(0, 10).split('-');
  return d ? `${d}.${m}.${y}` : String(v);
};

function describe(e: ServiceEvent): string {
  const p = e.payload ?? {};
  switch (e.kind) {
    case 'created':
      return p.offerId ? `Created on Settle of offer #${p.offerId}` : 'Created';
    case 'imported':
      return 'Imported';
    case 'delivered':
      return p.periodStart
        ? `Marked delivered, cycle ${day(p.periodStart)} - next renewal ${day(p.renewalDate)}`
        : 'Marked delivered';
    case 'cycle_start_changed':
      return `Cycle start: ${day(p.from)} -> ${day(p.to)}`;
    case 'renewal_date_changed':
      return `Next renewal: ${day(p.from)} -> ${day(p.to)}`;
    case 'commented':
      return 'Comment added';
    case 'file_added':
      return `File added${p.filename ? `: ${p.filename}` : ''}`;
    default:
      return e.kind;
  }
}

export function ServiceHistory({ serviceId }: { serviceId: number }) {
  const { data, isLoading } = useServiceEvents(serviceId, true);
  return (
    <Stack gap={4}>
      <Text fz="xs" fw={600} c="dimmed" tt="uppercase">
        History
      </Text>
      {(data ?? []).length === 0 && (
        <Text fz="xs" c="dimmed">
          {isLoading ? 'Loading...' : 'No events'}
        </Text>
      )}
      {(data ?? []).map((e) => (
        <Stack key={e.id} gap={0}>
          <Text fz="xs" c="dimmed">
            {e.actorName ?? e.actorEmail ?? 'System'},{' '}
            {dayjs(e.createdAt).format('DD.MM.YYYY HH:mm')}
          </Text>
          <Text fz="sm">{describe(e)}</Text>
        </Stack>
      ))}
    </Stack>
  );
}
